import { render, staticRenderFns } from "./MainRender.vue?vue&type=template&id=148cde60&scoped=true"
import script from "./MainRender.vue?vue&type=script&lang=js"
export * from "./MainRender.vue?vue&type=script&lang=js"
import style0 from "./MainRender.vue?vue&type=style&index=0&id=148cde60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148cde60",
  null
  
)

export default component.exports